import { platformID, UTM } from "./constants";

export const ANALYTICS_FIELDS = () => {
  return [
    {
      name: "gclid",
      value:
        window?.localStorage?.getItem(platformID.gclid) != null
          ? window?.localStorage?.getItem(platformID.gclid)
          : ""
    },
    {
      name: "fbclid",
      value:
        window?.localStorage?.getItem(platformID.fbclid) != null
          ? window?.localStorage?.getItem(platformID.fbclid)
          : ""
    },
    {
      name: "li_fat_id",
      value:
        window?.localStorage?.getItem(platformID.li_fat_id) != null
          ? window?.localStorage?.getItem(platformID.li_fat_id)
          : ""
    },
    {
      name: "utm_content",
      value:
        window?.localStorage?.getItem(UTM.content) != null
          ? window?.localStorage?.getItem(UTM.content)
          : ""
    },
    {
      name: "utm_medium",
      value:
        window?.localStorage?.getItem(UTM.medium) != null
          ? window?.localStorage?.getItem(UTM.medium)
          : ""
    },
    {
      name: "utm_source",
      value:
        window?.localStorage?.getItem(UTM.source) != null
          ? window?.localStorage?.getItem(UTM.source)
          : ""
    },
    {
      name: "utm_term",
      value:
        window?.localStorage?.getItem(UTM.term) != null
          ? window?.localStorage?.getItem(UTM.term)
          : ""
    },
    {
      name: "utm_campaign",
      value:
        window?.localStorage?.getItem(UTM.campaign) != null
          ? window?.localStorage?.getItem(UTM.campaign)
          : ""
    },
    {
      name: "utm_id",
      value:
        window?.localStorage?.getItem(UTM.id) != null
          ? window?.localStorage?.getItem(UTM.id)
          : ""
    },
    {
      name: "google_analytics_client_id",
      value:
        window?.localStorage?.getItem("google_analytics_client_id") != null
          ? window?.localStorage?.getItem("google_analytics_client_id")
          : ""
    },
    {
      name: "partner_key",
      value:
        window?.localStorage?.getItem("partner_key") != null
          ? window?.localStorage?.getItem("partner_key")
          : ""
    },
    {
      name: "acquisition_channel_source",
      value:
        window?.localStorage?.getItem("acquisition_channel_source") != null
          ? window?.localStorage?.getItem("acquisition_channel_source")
          : ""
    }
  ];
};

export const GOOGLE_OPTIMIZE_VARIANT = language => {
  return [
    {
      name: "google_optimize_variant", // send 1 or 0 only for EN demo form as it has relevant hidden field
      value:
        language === "en-US"
          ? window?.localStorage?.getItem("google_optimize_variant") != null
            ? window?.localStorage?.getItem("google_optimize_variant")
            : "0"
          : ""
    }
  ];
};